var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyCheckPoint = function SvgHappyCheckPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m3.73 4.171a.86.86 0 0 0-.788.357L7.507 9.213a.18.18 0 0 1-.126.07.17.17 0 0 1-.135-.05L5.622 7.846A.859.859 0 0 0 4.408 9.06l2.473 2.234c.16.162.38.252.607.252h.069a.86.86 0 0 0 .626-.348l4.144-5.655a.862.862 0 0 0-.596-1.372z"
  })));
};
export default SvgHappyCheckPoint;